import * as CookieConsent from "vanilla-cookieconsent";

export default class CookieBar {
    constructor() {
        // obtain plugin
        this.settings = cookiesettings;
        this.blocks = this.settings.blocks.map((item, key) => {
            return {
                title: item.title,
                description: item.description,
                linkedCategory: item.toggle_value
            };
        });

        // run plugin with your configuration
        CookieConsent.run({
            categories: {
                necessary: {
                    enabled: true,  // this category is enabled by default
                    readOnly: true  // this category cannot be disabled
                },
                analytics: {}
            },
            current_lang: 'de',
            autoclear_cookies: true,                   // default: false
            page_scripts: true,                        // default: false
            cookie_expiration: 1,                 // default: 182 (days)
            guiOptions: {
                consentModal: {
                    layout: 'cloud',
                    position: 'bottom right',
                    flipButtons: false,
                    equalWeightButtons: false
                },
                preferencesModal: {
                    layout: 'box',
                    // position: 'right',
                    flipButtons: false,
                    equalWeightButtons: false
                }
            },
            language: {
                default: 'de',
                translations: {
                    de: {
                        consentModal: {
                            title: this.settings.title,
                            description: this.settings.description,
                            acceptAllBtn: this.settings.accept_all_label,
                            acceptNecessaryBtn: this.settings.deny_all_label,
                            showPreferencesBtn: 'Cookie Einstellungen',
                        },
                        preferencesModal: {
                            title: this.settings.settings_title,
                            savePreferencesBtn: this.settings.save_label,
                            acceptAllBtn: this.settings.accept_all_label,
                            acceptNecessaryBtn: this.settings.deny_all_label,
                            closeIconLabel: this.settings.close_label,
                            sections: this.blocks
                        }
                    }
                }
            }
        });
    }
}
